/* eslint-disable max-len */
import { useCallback } from 'react';
import useRequestConfigs from '../useRequestConfigs';
export default function useOnAddToCart(cioClient, callback) {
    const { getRequestConfigs } = useRequestConfigs();
    const requestConfigs = getRequestConfigs();
    if (!requestConfigs) {
        throw new Error('This hook is meant to be used within the CioPlp provider.');
    }
    return useCallback((event, item, revenue, selectedVariationId) => {
        const { itemId, itemName, variationId } = item;
        const { query, section } = requestConfigs;
        let selectedVariation;
        if (cioClient) {
            cioClient.tracker.trackConversion(query, {
                itemId,
                itemName,
                variationId: selectedVariationId || variationId,
                revenue,
                section,
            });
        }
        if (selectedVariationId) {
            selectedVariation = item.variations?.filter((variation) => variation.variationId === selectedVariationId)?.[0];
        }
        if (callback)
            callback(event, item, selectedVariation);
        event.preventDefault();
        event.stopPropagation();
    }, [callback, cioClient, requestConfigs]);
}
